module.exports = __webpack_public_path__ + "static/media/2.fc6776b0.jpg";